(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function() {
  var loadProductRecommendationsIntoSection = function(section) {
    if (!section) return;

    var request = new XMLHttpRequest();
    request.open("GET", section.dataset.url);

    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;

        var incoming = container.querySelector(".related-products");
        if (incoming) {
          section.innerHTML = incoming.innerHTML;
        }
      }
    };

    request.send();
  };

  var initRelatedSections = function() {
    var sections = document.querySelectorAll(".related-products");
    if (!sections.length) return;

    sections.forEach(function(section) {
      loadProductRecommendationsIntoSection(section);
    });
  };

  document.addEventListener("shopify:section:load", function(event) {
    var section = document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products');
    if (section) {
      loadProductRecommendationsIntoSection(section);
    }
  });

  initRelatedSections();
})();

  } catch(e) { console.error(e); }
})();
})();
